export type ShopItem = {
  id: string;
  name: string;
  cost: number;
  image: string;
};

const item = (id: string, name: string, cost: number): ShopItem => ({
  id,
  name,
  cost,
  image: `/shop/${id}.png`,
});

const CATALOG: [id: string, name: string, cost: number][] = [
  ["yoyo", "Yo-yo", 1],
  ["sticker", "Sticker", 1],
  ["balloon", "Balloon", 1],
  ["hat", "Hat", 2],
  ["crayon", "Crayon", 2],
  ["pinwheel", "Pinwheel", 2],
  ["baseball-bat", "Baseball bat", 3],
  ["jump-rope", "Jump rope", 3],
  ["spinning-top", "Spinning top", 3],
  ["football", "Football", 4],
  ["soccer-ball", "Soccer ball", 4],
  ["frisbee", "Frisbee", 4],
  ["gloves", "Gloves", 5],
  ["bunny", "Bunny", 5],
  ["surfboard", "Surfboard", 5],
  ["book", "Book", 6],
  ["paintbrush", "Paintbrush", 6],
  ["markers", "Markers", 6],
  ["drum", "Drum", 7],
  ["harmonica", "Harmonica", 7],
  ["kazoo", "Kazoo", 7],
  ["guitar", "Guitar", 8],
  ["microphone", "Microphone", 8],
  ["xylophone", "Xylophone", 8],
  ["camera", "Camera", 9],
  ["flashlight", "Flashlight", 9],
  ["magnifying-glass", "Magnifying glass", 9],
  ["radio", "Radio", 10],
  ["tent", "Tent", 10],
  ["kitten", "Kitten", 10],
  ["scooter", "Scooter", 11],
  ["skateboard", "Skateboard", 11],
  ["roller-skates", "Roller skates", 11],
  ["telescope", "Telescope", 12],
  ["binoculars", "Binoculars", 12],
  ["compass", "Compass", 12],
  ["backpack", "Backpack", 13],
  ["sleeping-bag", "Sleeping bag", 13],
  ["canteen", "Canteen", 13],
  ["bicycle", "Bicycle", 14],
  ["tricycle", "Tricycle", 14],
  ["wagon", "Wagon", 14],
  ["puppy", "Puppy", 15],
  ["shield", "Shield", 15],
  ["parrot", "Parrot", 15],
  ["pirate-hat", "Pirate hat", 16],
  ["treasure-map", "Treasure map", 16],
  ["spyglass", "Spyglass", 16],
  ["bow", "Bow and arrow", 17],
  ["helmet", "Helmet", 17],
  ["lasso", "Lasso", 17],
  ["robot", "Robot", 18],
  ["walkie-talkie", "Walkie-talkie", 18],
  ["drone", "Drone", 18],
  ["moon-lamp", "Moon lamp", 19],
  ["lantern", "Lantern", 19],
  ["night-light", "Night light", 19],
  ["tv", "T.V.", 20],
  ["pony", "Pony", 20],
  ["sword", "Sword", 20],
  ["unicorn", "Unicorn", 21],
  ["fairy-wings", "Fairy wings", 21],
  ["rainbow", "Rainbow", 21],
  ["campfire", "Campfire", 22],
  ["canoe", "Canoe", 22],
  ["fishing-rod", "Fishing rod", 22],
  ["garden", "Garden", 23],
  ["butterfly", "Butterfly", 23],
  ["ladybug", "Ladybug", 23],
  ["goldfish", "Goldfish", 24],
  ["owl", "Owl", 24],
  ["hamster", "Hamster", 24],
  ["bouquet", "Flower bouquet", 25],
  ["birdhouse", "Birdhouse", 25],
  ["sunflower", "Sunflower", 25],
  ["spaceship", "Spaceship", 26],
  ["satellite", "Satellite", 26],
  ["alien-toy", "Alien toy", 26],
  ["trampoline", "Trampoline", 27],
  ["pogo-stick", "Pogo stick", 27],
  ["hula-hoop", "Hula hoop", 27],
  ["kite", "Kite", 28],
  ["boomerang", "Boomerang", 28],
  ["bubble-machine", "Bubble machine", 28],
  ["paint-set", "Paint set", 29],
  ["easel", "Easel", 29],
  ["clay", "Modeling clay", 29],
  ["armor", "Armor", 30],
  ["magic-wand", "Magic wand", 30],
  ["barn", "Barn", 30],
  ["building-blocks", "Building blocks", 31],
  ["puppet", "Puppet", 31],
  ["teddy-bear", "Teddy bear", 31],
  ["dollhouse", "Dollhouse", 32],
  ["toy-train", "Toy train", 32],
  ["race-car", "Race car", 32],
  ["toy-boat", "Toy boat", 33],
  ["rubber-duck", "Rubber duck", 33],
  ["sandcastle", "Sandcastle", 33],
  ["microscope", "Microscope", 34],
  ["globe", "Globe", 34],
  ["abacus", "Abacus", 34],
  ["chess-set", "Chess set", 35],
  ["checkers", "Checkers", 35],
  ["jigsaw-puzzle", "Jigsaw puzzle", 35],
  ["keyboard", "Keyboard", 36],
  ["trumpet", "Trumpet", 36],
  ["violin", "Violin", 36],
  ["flute", "Flute", 37],
  ["maracas", "Maracas", 37],
  ["accordion", "Accordion", 37],
  ["basketball", "Basketball", 38],
  ["tennis-racket", "Tennis racket", 38],
  ["volleyball", "Volleyball", 38],
  ["hockey-stick", "Hockey stick", 39],
  ["baseball-glove", "Baseball glove", 39],
  ["goal-net", "Goal net", 39],
  ["car", "Car", 40],
  ["treehouse", "Treehouse", 40],
  ["big-tv", "Giant T.V.", 40],
  ["motorcycle", "Motorcycle", 41],
  ["jeep", "Jeep", 41],
  ["tractor", "Tractor", 41],
  ["sailboat", "Sailboat", 42],
  ["speedboat", "Speedboat", 42],
  ["submarine", "Submarine", 42],
  ["helicopter", "Helicopter", 43],
  ["hot-air-balloon", "Hot-air balloon", 43],
  ["blimp", "Blimp", 43],
  ["cabin", "Cabin", 44],
  ["lighthouse", "Lighthouse", 44],
  ["windmill", "Windmill", 44],
  ["fort", "Fort", 45],
  ["playground", "Playground", 45],
  ["swimming-pool", "Swimming pool", 45],
  ["greenhouse", "Greenhouse", 46],
  ["fountain", "Fountain", 46],
  ["waterfall", "Waterfall", 46],
  ["peacock", "Peacock", 47],
  ["panda", "Panda", 47],
  ["dolphin", "Dolphin", 47],
  ["elephant", "Elephant", 48],
  ["giraffe", "Giraffe", 48],
  ["lion", "Lion", 48],
  ["tiger", "Tiger", 49],
  ["zebra", "Zebra", 49],
  ["monkey", "Monkey", 49],
  ["dragon", "Dragon", 50],
  ["phoenix", "Phoenix", 50],
  ["griffin", "Griffin", 50],
  ["crystal-ball", "Crystal ball", 51],
  ["genie-lamp", "Genie lamp", 51],
  ["flying-carpet", "Flying carpet", 51],
  ["throne", "Throne", 52],
  ["scepter", "Scepter", 52],
  ["treasure-chest", "Treasure chest", 52],
  ["volcano", "Volcano", 53],
  ["canyon", "Canyon", 53],
  ["glacier", "Glacier", 53],
  ["aquarium", "Aquarium", 54],
  ["zoo", "Zoo", 54],
  ["observatory", "Observatory", 54],
  ["ferris-wheel", "Ferris wheel", 55],
  ["roller-coaster", "Roller coaster", 55],
  ["carousel", "Carousel", 55],
  ["movie-theater", "Movie theater", 56],
  ["circus-tent", "Circus tent", 56],
  ["theater-stage", "Theater stage", 56],
  ["snowmobile", "Snowmobile", 57],
  ["hovercraft", "Hovercraft", 57],
  ["monorail", "Monorail", 57],
  ["robot-dog", "Robot dog", 58],
  ["robot-dinosaur", "Robot dinosaur", 58],
  ["mech-suit", "Mech suit", 58],
  ["crystal-cave", "Crystal cave", 59],
  ["rainbow-bridge", "Rainbow bridge", 59],
  ["magic-door", "Magic door", 59],
  ["diamond-ring", "Diamond ring", 60],
  ["pirate-ship", "Pirate ship", 60],
  ["airplane", "Airplane", 60],
  ["yacht", "Yacht", 61],
  ["limousine", "Limousine", 61],
  ["fire-truck", "Fire truck", 61],
  ["ambulance", "Ambulance", 62],
  ["police-car", "Police car", 62],
  ["dump-truck", "Dump truck", 62],
  ["excavator", "Excavator", 63],
  ["crane", "Crane", 63],
  ["bulldozer", "Bulldozer", 63],
  ["steam-locomotive", "Steam locomotive", 64],
  ["freight-train", "Freight train", 64],
  ["maglev-train", "Maglev train", 64],
  ["mountain-cabin", "Mountain cabin", 65],
  ["igloo", "Igloo", 65],
  ["pyramid", "Pyramid", 65],
  ["pagoda", "Pagoda", 66],
  ["temple", "Temple", 66],
  ["colosseum", "Colosseum", 66],
  ["planetarium", "Planetarium", 67],
  ["museum", "Museum", 67],
  ["aquarium-tunnel", "Aquarium tunnel", 67],
  ["water-park", "Water park", 68],
  ["ski-lodge", "Ski lodge", 68],
  ["desert-oasis", "Desert oasis", 68],
  ["unicorn-stable", "Unicorn stable", 69],
  ["dragon-lair", "Dragon lair", 69],
  ["wizard-tower", "Wizard tower", 69],
  ["golden-harp", "Golden harp", 70],
  ["grand-piano", "Grand piano", 70],
  ["pipe-organ", "Pipe organ", 70],
  ["treasure-island", "Treasure island", 71],
  ["hidden-cove", "Hidden cove", 71],
  ["jungle-temple", "Jungle temple", 71],
  ["ice-palace", "Ice palace", 72],
  ["cloud-castle", "Cloud castle", 72],
  ["underwater-city", "Underwater city", 72],
  ["race-track", "Race track", 73],
  ["stadium", "Stadium", 73],
  ["arena", "Arena", 73],
  ["suspension-bridge", "Suspension bridge", 74],
  ["mountain-tunnel", "Mountain tunnel", 74],
  ["mountain-pass", "Mountain pass", 74],
  ["satellite-dish", "Satellite dish", 75],
  ["radio-tower", "Radio tower", 75],
  ["weather-station", "Weather station", 75],
  ["giant-robot", "Giant robot", 76],
  ["battle-mech", "Battle mech", 76],
  ["space-rover", "Space rover", 76],
  ["coral-reef", "Coral reef", 77],
  ["rainforest", "Rainforest", 77],
  ["northern-lights", "Northern lights", 77],
  ["wizard-staff", "Wizard staff", 78],
  ["magic-mirror", "Magic mirror", 78],
  ["spellbook", "Spellbook", 78],
  ["royal-carriage", "Royal carriage", 79],
  ["golden-chariot", "Golden chariot", 79],
  ["parade-float", "Parade float", 79],
  ["house", "House", 80],
  ["crown", "Crown", 80],
  ["rocket", "Rocket ship", 80],
  ["mansion", "Mansion", 81],
  ["palace", "Palace", 81],
  ["villa", "Villa", 81],
  ["skyscraper", "Skyscraper", 82],
  ["clock-tower", "Clock tower", 82],
  ["cathedral", "Cathedral", 82],
  ["cruise-ship", "Cruise ship", 83],
  ["aircraft-carrier", "Aircraft carrier", 83],
  ["tall-ship", "Tall ship", 83],
  ["jumbo-jet", "Jumbo jet", 84],
  ["space-shuttle", "Space shuttle", 84],
  ["flying-saucer", "Flying saucer", 84],
  ["theme-park", "Theme park", 85],
  ["safari-park", "Safari park", 85],
  ["dinosaur-park", "Dinosaur park", 85],
  ["golden-dragon", "Golden dragon", 86],
  ["giant-phoenix", "Giant phoenix", 86],
  ["sea-serpent", "Sea serpent", 86],
  ["enchanted-forest", "Enchanted forest", 87],
  ["floating-islands", "Floating islands", 87],
  ["crystal-kingdom", "Crystal kingdom", 87],
  ["time-machine", "Time machine", 88],
  ["portal-gate", "Portal gate", 88],
  ["wormhole", "Wormhole", 88],
  ["olympic-stadium", "Olympic stadium", 89],
  ["world-map", "World map", 89],
  ["trophy-cup", "Trophy cup", 89],
  ["golden-statue", "Golden statue", 90],
  ["ruby-tiara", "Ruby tiara", 90],
  ["emerald-necklace", "Emerald necklace", 90],
  ["volcano-island", "Volcano island", 91],
  ["mountain-kingdom", "Mountain kingdom", 91],
  ["sky-city", "Sky city", 91],
  ["moon-base", "Moon base", 92],
  ["mars-colony", "Mars colony", 92],
  ["asteroid-mine", "Asteroid mine", 92],
  ["royal-zoo", "Royal zoo", 93],
  ["dragon-sanctuary", "Dragon sanctuary", 93],
  ["unicorn-meadow", "Unicorn meadow", 93],
  ["treasure-vault", "Treasure vault", 94],
  ["gold-mine", "Gold mine", 94],
  ["jewel-cave", "Jewel cave", 94],
  ["super-fortress", "Super fortress", 95],
  ["sky-fortress", "Sky fortress", 95],
  ["sea-fortress", "Sea fortress", 95],
  ["magic-kingdom", "Magic kingdom", 96],
  ["fairy-kingdom", "Fairy kingdom", 96],
  ["mermaid-palace", "Mermaid palace", 96],
  ["world-cruise", "World cruise", 97],
  ["safari-adventure", "Safari adventure", 97],
  ["polar-expedition", "Polar expedition", 97],
  ["giant-telescope", "Giant telescope", 98],
  ["invention-workshop", "Invention workshop", 98],
  ["science-lab", "Science lab", 98],
  ["rainbow-palace", "Rainbow palace", 99],
  ["aurora-tower", "Aurora tower", 99],
  ["sun-temple", "Sun temple", 99],
  ["castle", "Castle", 100],
  ["space-station", "Space station", 100],
  ["vacation-island", "Vacation island", 100],
  ["golden-castle", "Golden castle", 110],
  ["cloud-kingdom", "Cloud kingdom", 110],
  ["luxury-yacht", "Luxury yacht", 110],
  ["ice-kingdom", "Ice kingdom", 120],
  ["jungle-palace", "Jungle palace", 120],
  ["space-colony", "Space colony", 120],
  ["mountain-palace", "Mountain palace", 130],
  ["coral-palace", "Coral palace", 130],
  ["comet-ship", "Comet ship", 130],
  ["crystal-spire", "Crystal spire", 140],
  ["sky-palace", "Sky palace", 140],
  ["moon-palace", "Moon palace", 140],
  ["dragon-castle", "Dragon castle", 150],
  ["ocean-kingdom", "Ocean kingdom", 150],
  ["solar-sailer", "Solar sailer", 150],
  ["phoenix-nest", "Phoenix nest", 160],
  ["hidden-kingdom", "Hidden kingdom", 160],
  ["star-harbor", "Star harbor", 160],
  ["titan-statue", "Titan statue", 170],
  ["lost-city", "Lost city", 170],
  ["nebula-garden", "Nebula garden", 170],
  ["world-tree", "World tree", 180],
  ["sky-ark", "Sky ark", 180],
  ["cosmic-garden", "Cosmic garden", 180],
  ["eternity-gate", "Eternity gate", 190],
  ["dream-island", "Dream island", 190],
  ["galaxy-core", "Galaxy core", 190],
  ["wonder-world", "Wonder world", 200],
  ["star-palace", "Star palace", 200],
  ["endless-kingdom", "Endless kingdom", 200],
];

export const SHOP_ITEMS: ShopItem[] = CATALOG.map(([id, name, cost]) => item(id, name, cost));

export const shopItemById = (id: string): ShopItem | undefined => SHOP_ITEMS.find((item) => item.id === id);

export const SHOP_COLUMNS = 3;
export const SHOP_TEASE_ROWS = 4;
export const SHOP_SPEND_STEP = 10;

export const shopCoinsSpent = (inventory: string[]): number => {
  return inventory.reduce((sum, id) => sum + (shopItemById(id)?.cost ?? 0), 0);
};

export const shopSpendNeededForCost = (cost: number): number => {
  if (cost < SHOP_SPEND_STEP) return 0;
  const decade = SHOP_SPEND_STEP * Math.floor(cost / SHOP_SPEND_STEP);
  return decade <= 100 ? decade : decade - SHOP_SPEND_STEP;
};

export const visibleShopCount = (spent: number): number => {
  const spentCoins = Math.max(0, Math.round(spent));
  let count = 0;
  for (const entry of SHOP_ITEMS) {
    if (shopSpendNeededForCost(entry.cost) > spentCoins) break;
    count += 1;
  }
  return count;
};

export const lifetimeCoins = (coins: number, inventory: string[], coinsEarned = 0): number => {
  const spent = shopCoinsSpent(inventory);
  return Math.max(coinsEarned, coins + spent);
};

export const shopTeaseCount = (spent: number): number => {
  const reveal = visibleShopCount(spent);
  return Math.min(SHOP_ITEMS.length, reveal + SHOP_COLUMNS * SHOP_TEASE_ROWS);
};

export const hiddenShopRow = (index: number, reveal: number): 0 | 1 | 2 | 3 | null => {
  if (index < reveal) return null;
  const row = Math.floor((index - reveal) / SHOP_COLUMNS);
  if (row < 0 || row >= SHOP_TEASE_ROWS) return null;
  return row as 0 | 1 | 2 | 3;
};

export const shopMysteryClass = (hidden: 0 | 1 | 2 | 3 | null): string => {
  if (hidden === null) return "";
  return `mystery-${hidden}`;
};

export const nextShopSpendUnlock = (spent: number): number | null => {
  const spentCoins = Math.max(0, Math.round(spent));
  let next: number | null = null;
  for (const entry of SHOP_ITEMS) {
    const needed = shopSpendNeededForCost(entry.cost);
    if (needed > spentCoins && (next === null || needed < next)) {
      next = needed;
    }
  }
  return next === null ? null : next - spentCoins;
};

export const shopUnlockMessage = (spent: number): string | null => {
  const more = nextShopSpendUnlock(spent);
  if (more === null) return null;
  const cost = Math.max(0, Math.round(spent)) + more;
  return `Purchase an item that costs ${cost} or more to unlock more items`;
};
